import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
const GoogleReviewMessage = () => (((process.env.CLIENT == null ? true : null) && <FormattedMessage tagName="p" id="googleReviewMessage.message" defaultMessage={"Thank you for choosing the DCMS ServiceLink® Payment Portal. Would you kindly take a moment "
    + "to tell us about your recent experience? {googleLink} or if your experience wasn’t "
    + "great, we want to make it right, please {contactLink}."} values={{
    googleLink: (<a className="link" href="https://g.page/r/CXlNPPpvVG_sEAI/review">
					<FormattedMessage id="googleReviewMessage.message.googleLink" defaultMessage="Review us on Google"/>
				</a>),
    contactLink: (<Link className="link" to="/public/contact">
					<FormattedMessage id="googleReviewMessage.message.contactLink" defaultMessage="contact us"/>
				</Link>)
}}/>));
export default GoogleReviewMessage;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/GoogleReviewMessage/GoogleReviewMessage.tsx